import { useRef } from 'react';
import { useAppSelector } from './redux';
import { liveOhtRuntimeStore } from '../store/liveOhtRuntimeStore';
import { replaySnapshotStore } from '../store/replaySnapshotStore';

/**
 * Which docks currently hold a FOUP, in left→right index order.
 * `undefined` while simulation is off so 2D keeps its reference FOUPs.
 */
export function useEquipmentOccupiedPorts(portIds: readonly string[]): number[] | undefined {
  const running = useAppSelector((state) => state.simulation.running);
  const source = useAppSelector((state) => state.simulation.source);
  const hasPorts = portIds.length > 0;
  const simulationTime = useAppSelector((state) => (running && hasPorts ? state.simulation.simulationTime : 0));
  const prevResultRef = useRef<number[] | undefined>(undefined);

  if (!running || !hasPorts) {
    prevResultRef.current = undefined;
    return undefined;
  }
  void simulationTime;

  const livePortFoupIds = source === 'live' ? liveOhtRuntimeStore.getFrame().portFoupIds : null;
  const snapshot = replaySnapshotStore.getSnapshot();
  const occupied: number[] = [];
  portIds.forEach((id, index) => {
    if (livePortFoupIds) {
      if ((livePortFoupIds[id]?.length ?? 0) > 0) occupied.push(index);
      return;
    }
    const port = snapshot?.ports[id];
    if (!port) return;
    if (port.inventory > 0 || port.occupiedFoupIds.length > 0) occupied.push(index);
  });

  const prev = prevResultRef.current;
  if (prev && prev.length === occupied.length && prev.every((val, idx) => val === occupied[idx])) {
    return prev;
  }
  prevResultRef.current = occupied;
  return occupied;
}
